const langAdminUserEmailNotifications = {
	title: {
		tag: 'admin.user_email_notifications.title',
		fr: 'Stats par contact',
		en: 'Stats by contact',
	},
	column_user_name: {
		tag: 'admin.user_email_notifications.column_user_name',
		fr: 'Nom du contact',
		en: 'Contact name',
	},
	column_user_firstname: {
		tag: 'admin.user_email_notifications.column_user_firstname',
		fr: 'Prénom du contact',
		en: 'Contact firstname',
	},
	column_fund_name: {
		tag: 'admin.user_email_notifications.column_fund_name',
		fr: 'Nom du fonds',
		en: 'Fund name',
	},
	column_document_name: {
		tag: 'admin.user_email_notifications.column_document_name',
		fr: 'Nom du document',
		en: 'Document name',
	},
	column_user_email: {
		tag: 'admin.user_email_notifications.column_user_email',
		fr: 'E-mail',
		en: 'User email',
	},

	column_notification_send_datetime: {
		tag: 'admin.user_email_notifications.column_notification_send_datetime',
		fr: "Date d'envoi",
		en: 'Send date time',
	},
	column_notification_status: {
		tag: 'admin.user_email_notifications.column_notification_status',
		fr: 'Statut',
		en: 'Status',
	},
};

export default langAdminUserEmailNotifications;
